import { render, staticRenderFns } from "./ServicesHeader.vue?vue&type=template&id=56f105aa"
import script from "./ServicesHeader.vue?vue&type=script&lang=js"
export * from "./ServicesHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormSiteButton: require('/opt/atlassian/pipelines/agent/build/components/form/SiteButton.vue').default})
